"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: block;\n\tflex-flow: row nowrap;\n\tjustify-content: center;\n\talign-items: stretch;\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"], ["\n\tdisplay: block;\n\tflex-flow: row nowrap;\n\tjustify-content: center;\n\talign-items: stretch;\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"])));
var Viewport = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\toverflow: hidden;\n\theight: 100%;\n\n\t@media only screen and (pointer:coarse) {\n\t\toverflow-y: hidden;\n\t\toverflow-x: scroll;\n\t\tscrollbar-width: 0px;\n\t\tscrollbar-width: none;\n\t\t-ms-overflow-style: none;\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t\tscroll-snap-destination: center;\n\t\tscroll-snap-type: x mandatory;\n\t\tscroll-snap-type: mandatory;\n\t\t@supports (-webkit-overflow-scrolling: touch){\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t}\n\t}\n"], ["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\toverflow: hidden;\n\theight: 100%;\n\n\t@media only screen and (pointer:coarse) {\n\t\toverflow-y: hidden;\n\t\toverflow-x: scroll;\n\t\tscrollbar-width: 0px;\n\t\tscrollbar-width: none;\n\t\t-ms-overflow-style: none;\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t\tscroll-snap-destination: center;\n\t\tscroll-snap-type: x mandatory;\n\t\tscroll-snap-type: mandatory;\n\t\t@supports (-webkit-overflow-scrolling: touch){\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t}\n\t}\n"])));
var Content = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twhite-space: nowrap;\n\twidth:100%;\n\theight: 100%;\n\n\n\n\t", "\n\n"], ["\n\twhite-space: nowrap;\n\twidth:100%;\n\theight: 100%;\n\n\n\n\t", "\n\n"])), function (props) { return props.maxItems > 2 ? "padding: 0;" : ""; });
var IndicatorViewPort = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.indicatorViewPort; });
var IndicatorContent = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.indicatorContent; });
var Item = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tscroll-snap-align: center;\n\twidth: 100%;\n\theight: 100%;\n\tvertical-align: top;\n\tposition: relative;\n"], ["\n\tdisplay: inline-block;\n\tscroll-snap-align: center;\n\twidth: 100%;\n\theight: 100%;\n\tvertical-align: top;\n\tposition: relative;\n"])));
var Indicator = styled_components_1.default.li(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.indicator; });
var IndicatorText = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.indicatorText; });
// const IndicatorWrapper = styled.div<{altTheme: boolean, halfIndicator: boolean, altBackground: boolean}>`
// 	${props => props.theme.carousel.indicatorWrapper};
// 	z-index: 1;
// `;
var ButtonWrapper = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.buttonWrapper; });
var ScrollPrev = styled_components_1.default.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t", ";\n\t", ";\n"], ["\n\t", ";\n\t", ";\n"])), function (props) { return props.theme.carousel.scrollPrev; }, function (props) { return props.theme.carousel.navButton; });
var ScrollNext = styled_components_1.default.button(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t", ";\n\t", ";\n"], ["\n\t", ";\n\t", ";\n"])), function (props) { return props.theme.carousel.scrollNext; }, function (props) { return props.theme.carousel.navButton; });
var IndicatorContainer = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t", ";\n\twidth: unset;\n\tpadding-bottom: 14px;\n"], ["\n\t", ";\n\twidth: unset;\n\tpadding-bottom: 14px;\n"])), function (props) { return props.theme.carousel.indicatorContainer; });
var AltIndicatorContainer = styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.carousel.indicatorContainer; });
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.getItemSize = function () {
            var numItems = react_1.default.Children.count(_this.props.children);
            if (_this.indicatorContent.current) {
                return _this.indicatorContent.current.clientWidth / numItems;
            }
            return 0;
        };
        _this.getNumVisibleItems = function () {
            return _this.props.maxVisibleItems;
        };
        _this.onResize = function () {
            var numItems = react_1.default.Children.count(_this.props.children);
            var visibleItems = _this.getNumVisibleItems();
            if ((_this.state.focus > (numItems - visibleItems)) && !_this.props.centerOnFocus) {
                _this.setState(function (state) { return ({ focus: Math.min(state.focus, numItems - visibleItems) }); });
            }
            _this.snap(_this.state.current);
            _this.forceUpdate();
        };
        _this.scroll = function (dir) {
            _this.setState(function (state) { return ({ focus: state.focus + dir }); });
        };
        _this.generateIndicators = function (count, current, containerWidth) {
            var groups;
            var dataAutomationId = _this.props.automationIdPrefix + '_carousel_indicator_';
            if (_this.props.altTheme && _this.props.groupIndicators) {
                if (count > 10) {
                    var splitValue_1 = Math.ceil(count / 10);
                    var startContent_1 = null;
                    var groupIndex_1 = 0;
                    var maxIndex_1 = 0;
                    var minIndex_1 = 0;
                    react_1.default.Children.map(_this.props.children, function (child, index) {
                        var _a, _b;
                        groups = new Array();
                        maxIndex_1 = index;
                        if (minIndex_1 === index) {
                            startContent_1 = child;
                        }
                        if (maxIndex_1 - minIndex_1 === splitValue_1 || index === count - 1) {
                            var range_1 = maxIndex_1 - minIndex_1;
                            var selected = (current >= minIndex_1 && current <= maxIndex_1);
                            var text = (current + 1).toString() + "/" + count.toString();
                            var thumb = ((_a = _this.props.indicatorThumbs) === null || _a === void 0 ? void 0 : _a[index]) || ((_b = _this.props.children) === null || _b === void 0 ? void 0 : _b[index].props.src);
                            groups.push(react_1.default.createElement(AltIndicatorContainer, { width: 10, key: groupIndex_1, onClick: function () { _this.onChange(index - range_1); }, ref: function (ref) { _this.indicators[groupIndex_1] = ref; } },
                                _this.props.showIndicatorLabels &&
                                    react_1.default.createElement(IndicatorText, { selected: selected }, text),
                                react_1.default.createElement(Indicator, { "data-automationid": dataAutomationId + index, key: groupIndex_1, onClick: function () { _this.onChange(index - range_1); }, selected: selected, content: startContent_1, width: 100, altTheme: _this.props.altTheme, img: thumb })));
                            groupIndex_1++;
                            minIndex_1 = ++maxIndex_1;
                        }
                    });
                }
                else {
                    groups = react_1.default.Children.map(_this.props.children, function (child, index) {
                        var _a, _b;
                        return (react_1.default.createElement(AltIndicatorContainer, { width: containerWidth / count, key: index, onClick: function () { _this.onChange(index); }, ref: function (ref) { _this.indicators[index] = ref; } },
                            _this.props.showIndicatorLabels &&
                                react_1.default.createElement(IndicatorText, { selected: current === index },
                                    (current + 1).toString(),
                                    "/",
                                    count.toString()),
                            react_1.default.createElement(Indicator, { "data-automationid": dataAutomationId + index, key: index, onClick: function () { _this.onChange(index); }, selected: current === index, content: child, width: 100, altTheme: _this.props.altTheme, img: (_a = _this.props.children) === null || _a === void 0 ? void 0 : _a[index].props.src }, (_b = _this.props.indicatorThumbs) === null || _b === void 0 ? void 0 : _b[index])));
                    });
                }
            }
            else if (_this.props.altTheme) {
                groups = react_1.default.Children.map(_this.props.children, function (child, index) {
                    var _a, _b;
                    return (react_1.default.createElement(AltIndicatorContainer, { width: containerWidth / count, key: index, onClick: function () { _this.onChange(index); }, ref: function (ref) { _this.indicators[index] = ref; } },
                        _this.props.showIndicatorLabels &&
                            react_1.default.createElement(IndicatorText, { selected: current === index },
                                (current + 1).toString(),
                                "/",
                                count.toString()),
                        react_1.default.createElement(Indicator, { "data-automationid": dataAutomationId + index, key: index, onClick: function () { _this.onChange(index); }, selected: current === index, content: child, width: 100, altTheme: _this.props.altTheme, img: (_a = _this.props.children) === null || _a === void 0 ? void 0 : _a[index].props.src }, (_b = _this.props.indicatorThumbs) === null || _b === void 0 ? void 0 : _b[index])));
                });
            }
            else {
                groups = react_1.default.Children.map(_this.props.children, function (child, index) {
                    var _a, _b;
                    return (react_1.default.createElement(IndicatorContainer, { key: index, onClick: function () { _this.onChange(index); }, ref: function (ref) { _this.indicators[index] = ref; } },
                        _this.props.showIndicatorLabels &&
                            react_1.default.createElement(IndicatorText, { selected: current === index },
                                (current + 1).toString(),
                                "/",
                                count.toString()),
                        react_1.default.createElement(Indicator, { "data-automationid": dataAutomationId + index, key: index, onClick: function () { _this.onChange(index); }, selected: current === index, content: child, width: 100, altTheme: _this.props.altTheme, img: (_a = _this.props.children) === null || _a === void 0 ? void 0 : _a[index].props.src }, (_b = _this.props.indicatorThumbs) === null || _b === void 0 ? void 0 : _b[index])));
                });
            }
            return groups;
        };
        _this.onChange = function (index) {
            var element = _this.items[index];
            if (element && _this.viewport.current) {
                _this.viewport.current.scrollTo({ left: index * element.clientWidth, top: 0, behavior: "smooth" });
            }
        };
        _this.snap = function (index) {
            var element = _this.items[index];
            if (element && _this.viewport.current) {
                _this.viewport.current.scrollTo({ left: index * element.clientWidth, top: 0, behavior: "auto" });
            }
        };
        _this.onPrev = function (ev) {
            if (_this.state.current > 0) {
                _this.onChange(_this.state.current - 1);
            }
            ev.stopPropagation();
        };
        _this.onNext = function (ev) {
            if ((_this.props.children && typeof (_this.props.children) === "object") && (_this.state.current < Object.keys(_this.props.children).length - 1)) {
                _this.onChange(_this.state.current + 1);
            }
            ev.stopPropagation();
        };
        _this.container = react_1.default.createRef();
        _this.left = react_1.default.createRef();
        _this.right = react_1.default.createRef();
        _this.viewport = react_1.default.createRef();
        _this.content = react_1.default.createRef();
        _this.indicatorViewPort = react_1.default.createRef();
        _this.indicatorContent = react_1.default.createRef();
        _this.items = [];
        _this.indicators = [];
        _this.state = {
            focus: 0,
            current: 0,
        };
        _this.observer = new IntersectionObserver(function (entries) {
            var activated = entries.reduce(function (max, entry) {
                return (entry.intersectionRatio > max.intersectionRatio) ? entry : max;
            });
            requestAnimationFrame(function () {
                if (activated.intersectionRatio > 0) {
                    var index = Number(activated.target.getAttribute("data-key"));
                    _this.setState({ current: index });
                    if (_this.props.onChange) {
                        _this.props.onChange(index);
                    }
                }
            });
        }, {
            root: _this.viewport.current, threshold: 0.5
        });
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        this.forceUpdate(); //Now we have refs we can use the size information
        window.addEventListener("resize", this.onResize); //If ResizeObservers become standard, use them instead
        if (this.props.initial && this.items.length > 0) {
            this.snap(this.props.initial);
        }
    };
    Carousel.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.onResize);
    };
    Carousel.prototype.render = function () {
        var _this = this;
        var numItems = react_1.default.Children.count(this.props.children);
        if (numItems === 0) {
            return null;
        }
        var itemSize = this.getItemSize();
        var visibleItems = this.getNumVisibleItems();
        var children = react_1.default.Children.toArray(this.props.children);
        var left = -(itemSize * this.state.current);
        var indicatorViewPortWidth = this.indicatorViewPort.current ? this.indicatorViewPort.current.clientWidth : 100;
        if (this.indicatorViewPort.current && this.indicatorContent.current) {
            if (itemSize * children.length <= this.indicatorViewPort.current.clientWidth) {
                left = 0;
            }
            else {
                if (Math.abs(left) > this.indicatorViewPort.current.clientWidth / 2) {
                    left = left + this.indicatorViewPort.current.clientWidth / 2;
                }
                else {
                    left = 0;
                }
                if (this.indicatorContent.current.clientWidth + left <= this.indicatorViewPort.current.clientWidth) {
                    left = -(this.indicatorContent.current.clientWidth - this.indicatorViewPort.current.clientWidth + itemSize);
                }
            }
        }
        //left = left - 50;	// left hand padding
        var refocus = undefined;
        if (this.props.centerOnFocus) {
            //Wrap items & recalculate left to preserve smooth scroll
            if (this.state.focus < (numItems / 2)) {
            }
            else if (this.state.focus > (numItems / 2)) {
            }
            refocus = function (index) {
                _this.setState({ focus: index });
            };
        }
        var w = visibleItems * itemSize;
        if (isNaN(w)) {
            w = 0;
        }
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item) {
                this.observer.observe(item);
            }
        }
        return (react_1.default.createElement(Container, { ref: this.container, className: this.props.className },
            react_1.default.createElement(Viewport, { ref: this.viewport },
                react_1.default.createElement(Content, { ref: this.content, left: 0, maxItems: visibleItems }, children.map(function (child, index) {
                    var refocusInst = undefined;
                    if (refocus) {
                        refocusInst = function () { if (refocus) {
                            refocus(index);
                        } };
                    }
                    return (react_1.default.createElement(Item, { key: index, focused: index === _this.state.focus, "data-key": index, onClickCapture: refocusInst, ref: function (ref) { _this.items[index] = ref; } }, child));
                }))),
            children.length > 1 &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(IndicatorViewPort, { altTheme: this.props.altTheme, halfIndicator: this.props.halfIndicator, altBackground: this.props.altBackground, id: "carousel_indicator_viewport", ref: this.indicatorViewPort },
                        react_1.default.createElement(IndicatorContent, { left: left, id: "carousel_indicator_content", ref: this.indicatorContent }, this.generateIndicators(children.length, this.state.current, indicatorViewPortWidth))),
                    react_1.default.createElement(ButtonWrapper, { altTheme: this.props.altTheme, showButtons: this.props.showButtons, id: "carousel_buttonWrapper" },
                        react_1.default.createElement(ScrollPrev, { "data-automationid": this.props.automationIdPrefix + '_carousel_prev', onClick: this.onPrev, "aria-label": this.props.prevLabel, altTheme: this.props.altTheme }, this.props.theme.svgs.BTN_Arrow_Light),
                        react_1.default.createElement(ScrollNext, { "data-automationid": this.props.automationIdPrefix + '_carousel_next', onClick: this.onNext, "aria-label": this.props.prevLabel, altTheme: this.props.altTheme }, this.props.theme.svgs.BTN_Arrow_Light)))));
    };
    Carousel.defaultProps = {
        maxVisibleItems: 5,
        automationIdPrefix: "",
        centerOnFocus: false
    };
    return Carousel;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Carousel);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=Carousel.js.map